/**
 * Vernatics-specific functionality for board connectivity and WiFi configuration
 */
import tippy from 'tippy.js';
console.log('Vernatics module neww added');
export function initializeVernatiicsModal(currLang, iconConnect, iconBack) {
  const translateModalHtml = `
<div class="main output-panel modal-window modal-translate box-appearance"  >

<div class="more-modal-container screen-1">

<button class="button" id="connect-board" style="margin:0.5rem">
<text class="control-btn"> ${currLang['ConnectToBoard']} <i data-lucide="signal-high"></i> </text>
</button>
<button class="button" id="instruction-wifi" style="margin:0.5rem">
<text class="control-btn"> ${currLang['ConfigureWifi']} <i data-lucide="wifi"></i> </text>
</button>

</div>

<div class=" more-modal-container screen-2" style="display:none;overflow:visible;" >
<button class="back-btn-translate"  > <i data-lucide="arrow-big-left"></i>
</button>
<div >
<b for="input-ip" class="ip-label" style="margin:0.5rem">${currLang['ShareFeature.IpAddressLabel']}</b><br>
<input type="text" id="input-ip" name="saveIp" placeholder="${currLang['ShareFeature.IpAddressPlaceholder']}" style="margin:0.5rem"><br>
<label for="input-filename" class="filename-label" style="margin:0.5rem;display:none;">${currLang['ShareFeature.FileNameLabel']}</label>
<span id="device-controls" class="container">
        <input type="text" id="input-filename" name="saveFilename" placeholder="test.py">
        <button class="button" id="send-code">
            <i data-lucide="square-play"></i>
        </button>
        <button class="button" id="stop-code">
           <i data-lucide="rotate-ccw"></i>
        </button>
    </span><br>
    </div>
    <button class="button" id="establish-connection" style="margin:0.5rem">
    <text class="control-btn"> ${currLang['ShareFeature.Connect']} <i data-lucide="signal-high"></i> </text>
    </button>
    <text class="control-btn" id="connection-status"  style="margin:0.5rem;text-align:center;" >${currLang['ShareFeature.NotConnected']}</text>
    <button class="button" id="done-button" style="margin:0.5rem">
    <text class="control-btn"> ${currLang['ShareFeature.Done']} </text>
    </button>
</div>
<div class="more-modal-container  screen-3" style="display:none  ;max-height: 50vh">
<button class="back-btn-translate"  > <i data-lucide="arrow-big-left"></i>
</button>
<button class="instruct-btn-translate"  > <i data-lucide="info"></i>
</button>
 <div class="scrollable-content">
        <div class="steps-container" >
    <h4>${currLang['ShareFeature.HotspotSetupGuide']}</h4>
     <div class="step">
      <div class="step-content">
        <input type="text" id="input-device-ip" name="saveDeviceIp" placeholder="${currLang['ShareFeature.DeviceIpPlaceholder']}" style="margin:0.5rem;width:80%;max-width:15rem;text-align:center;background-color:white;">
        <button class="button" id="configure-wifi" style="margin:0.5rem;width:80%;max-width:15rem">
<text class="control-btn"> ${currLang['ShareFeature.ChangeWifiSettings']} <i data-lucide="wifi"></i> </text>
</button>
      </div>
    </div>
    <div class="instructions-steps">
    <h4>${currLang['ShareFeature.StepsToConfigureTheBoard']}</h4>
    <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
                <h5>${currLang['ShareFeature.EnterPairingMode']}</h5>
                <ol type="a">
                    <li>${currLang['ShareFeature.EnterPairingModeStepA']}</li>
                    <li>${currLang['ShareFeature.EnterPairingModeStepB']}</li>
                </ol>
            </div>
        </div>
        <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
                <h5>${currLang['ShareFeature.ConnectToHotspot']}</h5>
                <ol type="a">
                    <li>${currLang['ShareFeature.ConnectToHotspotStepA']}</li>
                    <li>${currLang['ShareFeature.ConnectToHotspotStepB']}</li>
                    <li>${currLang['ShareFeature.ConnectToHotspotStepC']}</li>
                </ol>
            </div>
        </div>
        <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
                <h5>${currLang['ShareFeature.SelectLocalNetwork']}</h5>
                <ol type="a">
                    <li>${currLang['ShareFeature.SelectLocalNetworkStepA']}</li>
                    <li>${currLang['ShareFeature.SelectLocalNetworkStepB']}</li>
                    <li>${currLang['ShareFeature.SelectLocalNetworkStepC']}</li>
                    <li>${currLang['ShareFeature.SelectLocalNetworkStepD']}</li>
                </ol>
            </div>
        </div>
        <div class="step">
            <div class="step-number">4</div>
            <div class="step-content">
                <h5>${currLang['ShareFeature.ConnectToLocalNetwork']}</h5>
                <ol type="a">
                    <li>${currLang['ShareFeature.ConnectToLocalNetworkStepA']}</li>
                    <li>${currLang['ShareFeature.ConnectToLocalNetworkStepB']}</li>
                </ol>
            </div>
        </div>
        <div class="step">
            <div class="step-number">5</div>
            <div class="step-content">
                <h5>${currLang['ShareFeature.ReconnectYourComputer']}</h5>
                <ol type="a">
                    <li>${currLang['ShareFeature.ReconnectYourComputerStepA']}</li>
                    <li>${currLang['ShareFeature.ReconnectYourComputerStepB']}</li>
                    <li>${currLang['ShareFeature.ReconnectYourComputerStepC']}</li>
                </ol>
            </div>
        </div>
    </div>
    
  </div>
      </div>

</div>

</div><div class="modal-window modal-wifi box-appearance"   >
<span class="close--translate--modal close-btn"><i data-lucide="x"></i> </span>
<div class="step-iframe"></div>
<button class="button" id="connect-board2" >
<text class="control-btn"> ${currLang['ConnectToBoard']} <i data-lucide="signal-high"></i> </text>
</button>
</div>
`;
  return translateModalHtml;
}

export function setupVernatiicsEventHandlers(
  currLang,
  closeModal,
  openWifiModal,
  openTranslateModal,
  validateAddress
) {
  const openTranslateModal_fn = openTranslateModal;
  document.querySelector('.overlay').style.display = 'block';
  // let closeBtn = document.querySelector('.close--translate--modal');
  // closeBtn.style.display = 'none';
  let backBtn = document.querySelectorAll('.back-btn-translate');
  let instructBtn = document.querySelector('.instruct-btn-translate');
  // const doneBtn = document.querySelector('#done-button');
  // doneBtn.style.display = 'none';
  const inputFilename = document.getElementById('input-filename');
  let connectBoardBtn = document.getElementById('connect-board');
  let connectBoardBtn2 = document.getElementById('connect-board2');
  let instructionWifiBtn = document.getElementById('instruction-wifi');
  let configureBtn = document.getElementById('configure-wifi');
  let connectionStatus = document.querySelector('#connection-status');
  let inputIp = document.querySelector('#input-ip');
  let checkIpStored = localStorage.getItem('savedIp');

  const establishConnectionFunc = async function (firstCall = null) {
    let errMsg = currLang['Game.ErrorText'] + ' 😖';
    if (firstCall) errMsg = currLang['ShareFeature.NotConnected'];
    try {
      let fetchAddress = validateAddress();
      if (!fetchAddress) {
        alert('Fields cant be empty');
        return;
      }
      connectionStatus.textContent = currLang['ShareFeature.Connecting'];
      let response = await fetch(`${fetchAddress}/establish-connection`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ip: inputIp.value }),
      });
      let res = await response.json();
      if (res) {
        if (res.connected == true) {
          connectionStatus.textContent = currLang['ShareFeature.Connected'];
          doneBtn.style.display = 'flex';
          document.querySelector('.back-btn-translate').style.display = 'none';
          inputIp.setAttribute('disabled', 'disabled');
          document.querySelector('#establish-connection').style.display = 'none';
          return true;
        } else {
          connectionStatus.textContent = errMsg;
        }
      }
    } catch (err) {
      console.log(err);
      connectionStatus.textContent = errMsg;
    }
  };

  const checkIpFunc = async function (el) {
    el.value = JSON.parse(checkIpStored);
    let isConnected = await establishConnectionFunc(true);

    if (isConnected) {
      let translateModalEl = {
        target: document.querySelector('.modal-translate'),
      };
      connectToBoardBtnScreen();
      closeModal(translateModalEl);
      toggleTranslateEls();
    }
  };

  const toggleTranslateEls = function () {
    document.getElementById('device-controls').style.display = 'inline-flex';
    document.querySelector('.filename-label').style.display = 'block';
    document.querySelector('.ip-label').textContent = currLang['ShareFeature.SaveCodeToDevice'];
    document.querySelector('#input-ip').style.display = 'none';
    connectionStatus.textContent = '';
  };

  const connectToBoardBtnScreen = function () {
    document.querySelector('.screen-1').style.display = 'none';
    document.querySelector('.screen-2').style.display = 'flex';
    document.querySelector('.screen-3').style.display = 'none';
  };

  document.addEventListener('DOMContentLoaded', function () {
    let vernaticsRoute = JSON.parse(sessionStorage.getItem('vernaticsAuth'));
    console.log(vernaticsRoute, checkIpStored, checkIpStored && !vernaticsRoute);
    if (vernaticsRoute) {
      sessionStorage.setItem('vernaticsAuth', false);
      return;
    }
    if (checkIpStored && !Boolean(vernaticsRoute)) {
      checkIpFunc(inputIp);
    }
  });

  tippy('#send-code', {
    content: 'Execute code',
    placement: 'top',
    zIndex: 99999999999,
  });
  tippy('#stop-code', {
    content: 'Stop execution',
    placement: 'top',
    zIndex: 99999999999,
  });

  let checkFilenameSaved = localStorage.getItem('savedFilename');
  if (checkFilenameSaved) {
    inputFilename.value = JSON.parse(checkFilenameSaved);
  }

  inputIp.addEventListener('change', function () {
    let ipValue = inputIp.value;
    if (ipValue) {
      localStorage.setItem('savedIp', JSON.stringify(ipValue));
    }
  });

  inputFilename.addEventListener('change', function () {
    const selectedValue = inputFilename.value;
    if (selectedValue) {
      localStorage.setItem('savedFilename', JSON.stringify(selectedValue));
    }
  });

  const sendCode = document.querySelector('#send-code');
  sendCode.addEventListener('click', async function () {
    try {
      let fetchAddress = validateAddress();
      if (!fetchAddress || inputFilename.value.length === 0) {
        alert('Fields cant be empty');
        return;
      }
      let code = document.getElementById('code-container');
      connectionStatus.textContent = 'Code is being executed ⏳';
      let responseUpload = await fetch(`${fetchAddress}/upload`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          pythonCode: code.value,
          name: inputFilename.value,
        }),
      });
      let res = await responseUpload.json();
      if (res.stat) {
        let responseRun = await fetch(`${fetchAddress}/run`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ file: inputFilename.value }),
        });
        let res2 = await responseRun.json();
        console.log(res2);
        document.querySelector('#visualisation').innerText = res2.value;
        connectionStatus.textContent = 'Execution Successful 👍';
      }
    } catch (err) {
      console.log(err);
    }
  });

  const stopCode = document.querySelector('#stop-code');
  stopCode.addEventListener('click', async function () {
    try {
      let fetchAddress = validateAddress();
      if (!fetchAddress) {
        alert('Fields cant be empty');
        return;
      }
      connectionStatus.textContent = 'Stopping execution 🚫';
      let response = await fetch(`${fetchAddress}/stop`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ file: inputFilename.value }),
      });
      let res = await response.json();
      if (res.stat === true || res.stat === false) {
        document.querySelector('#visualisation').innerText = '';
        connectionStatus.textContent = 'Execution stopped 🛑';
      }
    } catch (err) {
      console.log(err);
    }
  });

  const establishConnection = document.querySelector('#establish-connection');
  establishConnection.addEventListener('click', establishConnectionFunc);

  instructionWifiBtn.addEventListener('click', function () {
    document.querySelector('.screen-1').style.display = 'none';
    document.querySelector('.screen-2').style.display = 'none';
    document.querySelector('.screen-3').style.display = 'flex';
  });

  instructBtn.addEventListener('click', function () {
    let instructEl = document.querySelector('.instructions-steps');
    if (instructEl.style.maxHeight) {
      instructEl.style.maxHeight = null;
      instructEl.style.padding = '0 10px';
    } else {
      instructEl.style.maxHeight = instructEl.scrollHeight + 100 + 'px';
      instructEl.style.padding = '10px';
    }
  });

  backBtn.forEach((el) =>
    el.addEventListener('click', function () {
      document.querySelector('.screen-1').style.display = 'flex';
      document.querySelector('.screen-2').style.display = 'none';
      document.querySelector('.screen-3').style.display = 'none';
    })
  );

  connectBoardBtn.addEventListener('click', function () {
    connectToBoardBtnScreen();
  });

  connectBoardBtn2.addEventListener('click', function (e) {
    closeModal(e);
    document.querySelector('.screen-1').style.display = 'none';
    document.querySelector('.screen-2').style.display = 'flex';
    document.querySelector('.screen-3').style.display = 'none';
  });

  configureBtn.addEventListener('click', function () {
    let ipValueWifi = document.getElementById('input-device-ip').value;
    if (ipValueWifi.length === 0) {
      alert("ip can't be empty");
      return;
    }
    openWifiModal();
    document.querySelector('.step-iframe').innerHTML = `
      <iframe src="https://${ipValueWifi}:8000" title="description" style="height:90%;width:100%"></iframe>`;
    console.log('click');
  });

  doneBtn.addEventListener('click', function (e) {
    closeModal(e);
    toggleTranslateEls();
  });
}

/**
 * Helper: Delay execution
 */
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
